var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c(_setup.Head),_c('router-view'),_c(_setup.MyFooter,{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }